import { z } from 'zod';

import { sensorStatusSchema } from './sensor';

export type SensorData = z.infer<typeof sensorDataSchema>;
export const sensorDataSchema = z.object({
  sensorDataId: z.number(),
  sensorId: z.number(),
  sensorLocalId: z.number().nullable(),
  createdAt: z.string(),
  sensorStatus: sensorStatusSchema,
  relativeHumidity: z.number().nullable(),
  temperature: z.number().nullable(),
  moisture: z.number().nullable(),
  woodMoisture: z.number().nullable(),
  signalLevel: z.number().nullable(),
  reverseMoistureTransportStatus: z.number().int().min(0).max(4).nullable().optional(),
});

export type SensorDataAggregated = z.infer<typeof sensorDataAggregatedSchema>;
export const sensorDataAggregatedSchema = z.object({
  sensorDataAggregatedId: z.number(),
  sensorId: z.number(),
  sensorLocalId: z.number(),
  sensorStatus: sensorStatusSchema.default('ok'),
  referenceDate: z.string(),
  relativeHumidityAvg: z.number().nullable(),
  temperatureDataCount: z.number().optional(),
  temperatureAvg: z.number().nullable(),
  temperatureSum: z.number().optional(),
  temperatureSumOfSquares: z.number().nullable().optional(),
  moistureDataCount: z.number().optional(),
  moistureSum: z.number().optional(),
  moistureSumOfSquares: z.number().nullable().optional(),
  moistureMax: z.number().nullable(),
  woodMoistureDataCount: z.number().optional(),
  woodMoistureSum: z.number().optional(),
  woodMoistureSumOfSquares: z.number().nullable().optional(),
  woodMoistureMax: z.number().nullable(),
  reverseMoistureTransportStatus: z.number().int().min(0).max(4).nullable().optional(),
});

/**
 * @deprecated import from @si/web instead
 */
export type FixedTimeRange = z.infer<typeof fixedTimeRangeSchema>;
/**
 * @deprecated import from @si/web instead
 */
export const fixedTimeRangeSchema = z.union([
  z.literal('lastYear'),
  z.literal('lastHalfYear'),
  z.literal('lastThreeMonths'),
  z.literal('lastMonth'),
  z.literal('lastWeek'),
  z.literal('custom'),
]);

/**
 * @deprecated import from @si/web instead
 */
export type TimeRange = z.infer<typeof timeRangeSchema>;
/**
 * @deprecated import from @si/web instead
 */
export const timeRangeSchema = z.object({
  fixedTimeRange: fixedTimeRangeSchema.optional(),
  from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
